import { keyframes } from 'styled-components'

import { stepWizardCreate, stepWizardDefaultOptions } from '@subaio/components'

import { Loader } from 'components/Loader'

const animations = {
	forward: {
		in: {
			keyframes: keyframes`
				0% {
					opacity: 0;
				}

				100% {
					opacity: 1;
				}
			`,
			duration: 0,
			delay: 0,
		},
		out: {
			keyframes: keyframes`
				0% {
					opacity: 1;
				}

				100% {
					opacity: 0;
				}
			`,
			duration: 0,
		},
	},
	backward: {
		in: {
			keyframes: keyframes`
				0% {
					opacity: 0;
				}

				100% {
					opacity: 1;
				}
			`,
			duration: 0,
			delay: 0,
		},
		out: {
			keyframes: keyframes`
				0% {
					opacity: 1;
				}

				100% {
					opacity: 0;
				}
			`,
			duration: 0,
		},
	},
}

export const StepWizard = stepWizardCreate({
	animations,
	loader: {
		...stepWizardDefaultOptions.loader,
		Component: Loader,
	},
})
